import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";

const Box = styled(motion.li)`
  width: 23.5rem;
  height: 55vh;
  background-color: #ffffff;
  color: #000;
  padding: 1rem 2rem;
  margin-right: 2rem;
  border-radius: 0 50px 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  border: 1px solid #fff;
  transition: all 0.2s ease;

  &:hover {
    background-color: #000000;
    color: #fff;
    border: 1px solid #fff;
  }
  @media (max-width: 768px) {
    height: 50vh;
  }
  @media (max-width: 425px) {
    width: 22.5rem;
    height: 48vh;
  }
`;
const Title = styled.h2`
  font-size: calc(1.5em + 0.5vw);
`;

const Subtitle = styled.div`
  padding-top: 0.1rem;
  border-bottom: 2px solid #000;
  display: flex;
  flex-wrap: wrap;
  font-size: calc(0.75em + 0.3vw);
  ${Box}:hover & {
    border-bottom: 2px solid #fff;
  }
`;
const Subtitle2 = styled.div`
  padding-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  font-size: calc(0.7em + 0.3vw);
`;

// Framer motion configuration
const Item = {
  hidden: {
    scale: 0,
  },
  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const Card = (props) => {
  const { id, title, subtitle, description1, description2, description3 } =
    props.data;

  return (
    <Box key={id} variants={Item}>
      <Title className="font-bold">{title}</Title>
      <Subtitle>
        <span className="">{subtitle}</span>
      </Subtitle>
      <Subtitle2>{description1}</Subtitle2>
      <Subtitle2>{description2}</Subtitle2>
      <Subtitle2>{description3}</Subtitle2>
    </Box>
  );
};

export default Card;
